import { useEffect } from "react";
import Header from "./Header";
import Hero from "./Hero";
import Marquee from "./Marquee";
import CashDeposit from "./CashDeposit";
import HowItWorks from "./HowItWorks";
import Calculator from "./Calculator";
import Features from "./Features";
import Faq from "./Faq";
import FinalCTA from "./FinalCTA";
import Footer from "./Footer";
import LegalModal from "./LegalModal";
import { useState } from "react";

export default function Landing() {
  const [legalDoc, setLegalDoc] = useState(null);

  useEffect(() => {
    const saved = sessionStorage.getItem("cdm-scroll");
    sessionStorage.removeItem("cdm-scroll");
    if (saved) {
      const y = parseInt(saved, 10) || 0;
      if (window.__lenis) window.__lenis.scrollTo(y, { immediate: true });
      else window.scrollTo(0, y);
    }
  }, []);

  return (
    <>
      <Header />
      <main className="relative z-[2]">
        <Hero />
        <Marquee />
        <CashDeposit />
        <HowItWorks />
        <Calculator />
        <Features />
        <Faq />
        <FinalCTA />
      </main>
      <Footer onLegal={setLegalDoc} />
      <LegalModal doc={legalDoc} onClose={() => setLegalDoc(null)} />
    </>
  );
}
